/**
 * Clients service for API communication with the event clients endpoints.
 *
 * These endpoints are gamemaster/admin-only on the backend; the UI additionally
 * gates access by role.
 */

import apiClient from '../api/client';
import { Client } from '../types/clients';

/**
 * Fetch all claimed clients for an event.
 */
export async function fetchClients(eventId: string): Promise<Client[]> {
    const response = await apiClient.get<Client[]>(
        `/api/v1/events/${eventId}/clients`
    );
    return response.data;
}

/**
 * Kick (forcibly disconnect / revoke) a client bound to a unit.
 * Backend responds 204 No Content on success.
 */
export async function kickClient(eventId: string, unitId: string): Promise<void> {
    await apiClient.post(`/api/v1/events/${eventId}/clients/${unitId}/kick`);
}

/**
 * Kick (forcibly disconnect / revoke) every client in an event in a single
 * request. Returns the number of clients kicked.
 */
export async function kickAllClients(eventId: string): Promise<{ kicked: number }> {
    const response = await apiClient.post<{ kicked: number }>(
        `/api/v1/events/${eventId}/clients/kick-all`
    );
    return response.data;
}
